import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../stores/useAuthStore';
import { rememberReturnPath } from '../utils/returnPath';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const user = useAuthStore(state => state.user);
  const authReady = useAuthStore(state => state.authReady);
  const location = useLocation();

  // Persisted state can claim a session before the Firebase SDK has finished
  // restoring one. Redirecting during that window would sign people out on
  // every reload.
  if (!authReady) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="w-10 h-10 border-4 border-brand-line border-t-indigo-600 rounded-full animate-spin" />
      </div>
    );
  }

  if (!user) {
    // Survives the trip through WhatsApp's browser, which router state does not.
    rememberReturnPath(location.pathname);
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
